import Reveal from '@/components/base/Reveal';
import { communityGroups } from '@/mocks/community';

interface GroupGridProps {
  onRequestEntry: () => void;
}

export default function GroupGrid({ onRequestEntry }: GroupGridProps) {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {communityGroups.map((group, index) => (
        <Reveal key={group.id} delay={index * 60}>
          <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300">
            <div className="flex items-start justify-between">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className={`${group.icon} text-xl`} aria-hidden="true" />
              </span>
              <div className="flex flex-col items-end gap-1.5">
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-800">
                  {group.platform}
                </span>
                <span
                  className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${
                    group.status === '快满'
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-background-100 text-foreground-500'
                  }`}
                >
                  {group.status}
                </span>
              </div>
            </div>

            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{group.name}</h3>
            <p className="mt-2 flex-1 text-[13px] leading-relaxed text-foreground-600">{group.desc}</p>

            <div className="mt-4 flex flex-wrap gap-2">
              {group.tags.map((tag) => (
                <span key={tag} className="rounded-full bg-background-100 px-2.5 py-0.5 text-[11px] text-foreground-500">
                  {tag}
                </span>
              ))}
            </div>

            <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-4">
              <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-user-3-line" aria-hidden="true" />
                {group.members}
              </span>
              <button
                type="button"
                onClick={onRequestEntry}
                className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-500 px-3.5 py-2 text-xs font-semibold text-background-50 transition-colors hover:bg-secondary-600"
              >
                获取入口
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </button>
            </div>
          </article>
        </Reveal>
      ))}
    </div>
  );
}